import { Component, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {CalendlyModalComponent} from "../calendly-modal/calendly-modal.component";
import {CALENDLY_URL} from "../../shared/config";
import { ThemeService } from '../../shared/theme.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CalendlyModalComponent],
  template: `
  <header class="topbar">
    <div class="container topbar__inner">
      <a class="brand" routerLink="/">
        <span class="brand__mark"><img src="assets/data-bi-logo.svg" alt="Data BI" /></span>
        <span class="brand__name">Data BI <span class="brand__accent">Solutions</span></span>
      </a>

      <nav class="nav" [class.open]="open()">
        <a class="navBrand" routerLink="/" (click)="close()">
          <span class="navBrand__mark"><img src="assets/data-bi-logo.svg" alt="Data BI" /></span>
          <span class="navBrand__text">Data BI Solutions</span>
        </a>

        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="close()">Accueil</a>
        <a routerLink="/about" routerLinkActive="active" (click)="close()">À propos</a>
        <a routerLink="/services" routerLinkActive="active" (click)="close()">Services</a>
        <a routerLink="/blog" routerLinkActive="active" (click)="close()">Blog</a>
        <a routerLink="/careers" routerLinkActive="active" (click)="close()">Carrières</a>
        <a routerLink="/contact" routerLinkActive="active" (click)="close()">Contact</a>

        <button class="themeBtn" type="button" (click)="toggleTheme()">
          {{ theme.theme() === 'dark' ? '☀️' : '🌙' }}
        </button>

        <button class="btn sm primary nav__cta" type="button" (click)="openCalendly()">Book Calendly</button>
        <a class="btn sm ghost" [href]="calendlyUrl" target="_blank" rel="noreferrer" (click)="close()">Ouvrir Calendly</a>
      </nav>

      <button class="menu" type="button" (click)="toggle()" aria-label="Menu">
        <span></span><span></span><span></span>
      </button>
    </div>
  </header>
  <app-calendly-modal
      [open]="calendlyOpen()"
      [url]="calendlyUrl"
      (closed)="calendlyOpen.set(false)">
  </app-calendly-modal>`,
  styles: [`
    .topbar{
      position: sticky;
      top: 0;
      z-index: 50;
      backdrop-filter: blur(10px);
      background: rgba(7,11,23,.62);
      border-bottom: 1px solid rgba(255,255,255,.08);
    }

    .topbar__inner{
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:16px;
      padding: 14px 0;
    }

    .brand{
      display:flex;
      align-items:center;
      gap:10px;
      font-weight:900;
      min-width: 0;
    }

    .brand__mark{
      width: 60px;
      height: 60px;
      flex: 0 0 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      overflow: hidden;
    }
    
    .brand__mark img{
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    .brand__name{
      letter-spacing:.2px;
      white-space: nowrap;
      color: rgba(235,240,255,.95);
    }

    .brand__accent{
      color: rgba(0,229,168,.95);
    }

    .nav{
      display:flex;
      align-items:center;
      gap:16px;
    }

    .navBrand{
      display:none;
      align-items:center;
      gap:10px;
      padding: 6px 4px 10px;
      margin-bottom: 2px;
      border-bottom: 1px solid rgba(255,255,255,.10);
    }

    .navBrand__mark{
      width: 38px;
      height: 38px;
      display:grid;
      place-items:center;
      border-radius: 12px;
      background: linear-gradient(135deg, rgba(79,125,255,.18), rgba(0,229,168,.16));
      border: 1px solid rgba(255,255,255,.12);
      overflow:hidden;
      flex: 0 0 auto;
    }

    .navBrand__mark img{
      width: 148%;
      height: 148%;
      object-fit: contain;
    }

    .navBrand__text{
      font-weight: 900;
      color: rgba(235,240,255,.96);
    }

    .nav a{
      color: rgba(235,240,255,.78);
      font-weight: 800;
      font-size: 14px;
      padding: 10px 10px;
      border-radius: 12px;
      transition: background .12s ease, color .12s ease;
    }

    .nav a:hover{
      color: #fff;
      background: rgba(255,255,255,.05);
    }

    .nav a.active{
      color:#fff;
      background: rgba(79,125,255,.12);
      border: 1px solid rgba(255,255,255,.10);
    }

    .nav__cta{
      margin-left: 6px;
    }

    .themeBtn{
      width:40px;
      height:40px;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,.12);
      background: rgba(255,255,255,.06);
      color: rgba(235,240,255,.92);
      cursor:pointer;
      display:grid;
      place-items:center;
      font-size:16px;
    }

    .menu{
      display:none;
      width:48px;
      height:48px;
      border-radius: 16px;
      border: 1px solid rgba(255,255,255,.12);
      background: rgba(255,255,255,.06);
      box-shadow: 0 12px 34px rgba(0,0,0,.18);
      cursor:pointer;
      transition: transform .18s ease, background .18s ease, border-color .18s ease;
    }

    .menu:hover{
      transform: translateY(-1px);
    }

    .menu span{
      display:block;
      width:18px;
      height:2px;
      margin:4px auto;
      background: rgba(235,240,255,.85);
      border-radius:2px;
    }

    @media (max-width: 860px){
      .brand__mark{
        width: 40px;
        height: 40px;
        flex-basis: 40px;
      }

      .brand__name{
        font-size: 15px;
      }

      .menu{
        display:inline-grid;
        place-items:center;
      }

      .nav{
        position: fixed;
        top:72px;
        left:10px;
        right:10px;
        z-index: 70;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        padding: 18px 16px 20px;
        border: 1px solid rgba(255,255,255,.10);
        border-radius: 26px;
        background: rgba(7,11,23,.94);
        backdrop-filter: blur(18px);
        box-shadow: 0 24px 70px rgba(0,0,0,.36);
        overflow-y: auto;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transform: translateY(-10px) scale(.985);
        transform-origin: top center;
        transition: opacity .2s ease, transform .2s ease, visibility .2s ease;
      }

      .nav.open{
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transform: translateY(0) scale(1);
      }

      .navBrand{
        display:flex;
        padding: 8px 6px 12px;
        margin-bottom: 6px;
      }

      .nav__cta{
        width: 100%;
        margin-left: 0;
        margin-top: 8px;
      }

      .themeBtn{
        width: 100%;
        border-radius: 16px;
        min-height: 46px;
        margin-top: 4px;
      }

      .nav a{
        padding: 14px 14px;
        font-size: 15px;
      }

      .nav > a.btn{
        width: 100%;
      }
    }

    @media (max-width: 560px){
      .brand{
        gap: 8px;
      }

      .brand__mark{
        width: 38px;
        height: 38px;
        flex-basis: 38px;
        border-radius: 12px;
      }

      .brand__mark img{
        width: 150%;
        height: 150%;
      }

      .brand__name{
        font-size: 14px;
      }
    }
    /* ===== LIGHT THEME SUPPORT ===== */

    :host-context(body[data-theme="light"]) .topbar{
      background: rgba(255,255,255,.92);
      border-bottom: 1px solid rgba(15,23,42,.08);
    }

    :host-context(body[data-theme="light"]) .brand__name{
      color:#0f172a;
    }

    :host-context(body[data-theme="light"]) .brand__accent{
      color:#10b981;
    }
    

    :host-context(body[data-theme="light"]) .menu{
      background: rgba(255,255,255,.9);
      border:1px solid rgba(15,23,42,.10);
      box-shadow:0 10px 30px rgba(15,23,42,.12);
    }

    :host-context(body[data-theme="light"]) .menu span{
      background:#0f172a;
    }

    /* desktop nav links */

    :host-context(body[data-theme="light"]) .nav a{
      color:#0f172a;
    }

    :host-context(body[data-theme="light"]) .nav a:hover{
      background:rgba(15,23,42,.06);
    }

    /* theme button */

    :host-context(body[data-theme="light"]) .themeBtn{
      border:1px solid rgba(15,23,42,.12);
      background:rgba(15,23,42,.04);
      color:#0f172a;
    }

    /* ===== MOBILE MENU ===== */

    @media (max-width:860px){

      :host-context(body[data-theme="light"]) .nav{
        background:linear-gradient(180deg,#ffffff 0%,#f8fafc 100%);
        border:1px solid rgba(15,23,42,.08);
        box-shadow:0 25px 80px rgba(15,23,42,.18);
        backdrop-filter:none;
      }

      :host-context(body[data-theme="light"]) .navBrand__text{
        color:#0f172a;
      }

      :host-context(body[data-theme="light"]) .nav a{
        color:#0f172a;
      }

      :host-context(body[data-theme="light"]) .nav a.active{
        color:#0f172a;
        background:rgba(79,125,255,.12);
        border:1px solid rgba(15,23,42,.08);
      }

    }
  `]

})
export class NavbarComponent {
  constructor(public theme: ThemeService) {}

  open = signal(false);
  calendlyOpen = signal(false);
  calendlyUrl = CALENDLY_URL;

  private syncMenuState(next: boolean){
    this.open.set(next);
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('menu-open', next);
    }
  }

  toggle(){ this.syncMenuState(!this.open()); }
  close(){ this.syncMenuState(false); }
  openCalendly(){ this.calendlyOpen.set(true); this.close(); }
  toggleTheme(){ this.theme.toggle(); }

}
